import { CollectionId } from "@genai/collection";

import { ApiAssistant, Assistant, AssistantId } from "../model";
import { OrganizationId } from "@genai/organization";

export function toAssistant(apiAssistant: ApiAssistant): Assistant {
  return {
    uuid: apiAssistant.uuid as AssistantId,
    name: apiAssistant.name,
    description: apiAssistant.description,
    systemPrompt: apiAssistant.system_prompt,
    contextPrompt: apiAssistant.context_prompt,
    distanceMetric: apiAssistant.distance_metric,
    collection: apiAssistant.collection as CollectionId,
    organization: apiAssistant.organization as OrganizationId,
    maxChunks: apiAssistant.max_chunks,
    postProcessingStrategies: apiAssistant.post_processing_strategies,
    ragChatMode: apiAssistant.rag_chat_mode,
    model: apiAssistant.model,
    introduction: apiAssistant.introduction,
    disclaimer: apiAssistant.disclaimer,
  };
}
